import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getPermissionList = createAsyncThunk(
    "permissions/get",
    async (data, { rejectWithValue }) => {
        try {
            const response = await Client(
                API_METHOD.GET,
                url.permissions,
                null
            );
            return response.data;
        } catch (error) {
            if (error) {
                return rejectWithValue(error);
            } else {
                return rejectWithValue("Something went wrong");
            }
        }
    }
);

